import { render, staticRenderFns } from "./caseStudy.vue?vue&type=template&id=10a495d2&scoped=true&"
import script from "./caseStudy.vue?vue&type=script&lang=js&"
export * from "./caseStudy.vue?vue&type=script&lang=js&"
import style0 from "./caseStudy.vue?vue&type=style&index=0&id=10a495d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a495d2",
  null
  
)

/* custom blocks */
import block0 from "./caseStudy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports